import React, { useState, useEffect, useRef } from "react";
import { useGlobalContext } from "../../GlobalContext";
import useDriverTeams from "../../Sevices/Driver Api/useDriverTeams";
import useDriver from "../../Sevices/Driver Api/useDriver";

const initialDriverData = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  password: "",
  teamId: "",
  transportType: "",
  transportDescription: "",
  licencePlate: "",
  tier: "",
};

const AddDriverModal = ({ isOpen, onClose, Refresh }) => {
  const { createDriverApi } = useDriver();
  const { teams, fetchDriverTeams } = useDriverTeams();

  const { AdminId } = useGlobalContext();
  const [formData, setFormData] = useState(initialDriverData);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openTeam, setOpenTeam] = useState(false);
  const teamRef = useRef(null);

  useEffect(() => {
    fetchDriverTeams();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (teamRef.current && !teamRef.current.contains(e.target)) {
        setOpenTeam(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);

    const payload = {
      ...formData,
      userType: "driver",
      tier: "beginner",
      adminId: AdminId,
    };

    await createDriverApi(payload, () => {
      setFormData(initialDriverData);
      Refresh?.();
      onClose();
    });

    setIsSubmitting(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white max-h-[90vh] overflow-y-auto w-full max-w-2xl rounded-xl shadow-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Add New Driver</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {Object.keys(initialDriverData).map((field) => {
            if (field === "userType" || field === "tier") return null;

            if (field === "teamId") {
              return (
                <div key={field}>
                  <div key={field}>
                    <label className="block text-sm font-medium capitalize mb-1">
                      Team
                    </label>

                    <div ref={teamRef} className="relative w-full">
                      <div
                        onClick={() => setOpenTeam(!openTeam)}
                        className="w-full border border-gray-300 px-3 py-2 rounded-md bg-white cursor-pointer"
                      >
                        {formData.teamId
                          ? teams.find((t) => t.id === formData.teamId)
                              ?.team_name
                          : "Select Team"}
                      </div>

                      {openTeam && (
                        <div className="absolute left-0 right-0 mt-1 bg-white border rounded-md shadow-md z-50 max-h-[220px] overflow-y-auto">
                          {teams?.map((team) => (
                            <div
                              key={team.id}
                              onClick={() => {
                                setFormData((prev) => ({
                                  ...prev,
                                  teamId: team.id,
                                }));
                                setOpenTeam(false);
                              }}
                              className="px-3 py-2 hover:bg-blue-50 cursor-pointer text-sm"
                            >
                              {team.team_name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            }

            return (
              <div key={field}>
                <label className="block text-sm font-medium capitalize mb-1">
                  {field.replace(/([A-Z])/g, " $1")}
                </label>
                <input
                  type={field === "password" ? "password" : "text"}
                  name={field}
                  autoComplete={field === "password" ? "new-password" : "off"}
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            );
          })}
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            {isSubmitting ? "Saving..." : "Save Driver"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDriverModal;
